import { Avatar, Box, Chip } from "@mui/material";
import { useContext, useState } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import { statusColors } from "../../constants/statusColors";

// Copie de la fonction getActionStyle utilisée pour colorer le statut

export default function TicketLine({ ticket, creator, onEdit, canEdit }) {
  const [hover, setHover] = useState(false);
  const { translate } = useContext(LanguageContext);

  // const { text: statusColor, background: statusBg } = getActionStyle(
  //   `Statut → ${ticket.status}`
  // );

  const statusBg = statusColors[ticket.status] || "#343a40";
  const statusColor = "#ffffff";

  const statusKeyMap = {
    Open: "Open",
    "Working on It": "WorkingOnIt",
    "In Staging": "InStaging",
    "In Test": "InTest",
    "In Production": "InProduction",
    "In review": "InReview",
    Closed: "Closed",
  };

  return (
    <Box
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={() => canEdit && onEdit(ticket)}
         sx={{
     display: "flex",
     cursor: canEdit ? "pointer" : "default",
     bgcolor: hover && canEdit ? "action.hover" : "background.paper",
     pt: "5px",
     pb: "5px",
     border: 1,
     borderColor: "divider",
     borderRadius: "15px",
     mt: "10px",
     alignItems: "center",
   }}
    >
      {/* Numéro */}
      <div
        style={{
          width: "17%",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          borderRight: 1, borderColor: "divider",
          // paddingLeft: "10px",
        }}
      >
        <div style={{ paddingLeft: "10px" }}>
          <Avatar
            src={creator.photoUrl}
            sx={{ width: 24, height: 24, mr: 1 }}
          />
        </div>
        <span
          style={{
            fontSize: 12,
            fontWeight: 500,
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            display: "inline-block",
            paddingRight: "5px",
          }}
        >
          {creator.email}
        </span>
      </div>
      <div
        style={{
          width: "7%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRight: "1px solid lightgrey",
        }}
      >
        <div
          style={{ paddingLeft: "5px", paddingRight: "5px", fontSize: "12px" }}
        >
          {ticket.ticketNumber}
        </div>
      </div>

      {/* Nom */}
      <div
        style={{
          width: "26%",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          borderRight: "1px solid lightgrey",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          minWidth: 0,
          flexShrink: 1,
        }}
      >
        <div
          style={{
            paddingLeft: "10px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontWeight: "500",
          }}
        >
          {ticket.ticketName}
        </div>
      </div>

      {/* Type */}
      <div
        style={{
          width: "14%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRight: "1px solid lightgrey",
        }}
      >
        {ticket.ticketType}
      </div>

      <div
        style={{
          width: "14%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRight: "1px solid lightgrey",
          padding: "0 8px",
          boxSizing: "border-box",
        }}
      >
        <Chip
          icon={
            <Box
              component="span"
              sx={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                bgcolor:
                  ticket.priority === "High"
                    ? "red"
                    : ticket.priority === "Medium"
                    ? "#ffc107"
                    : "#28a745",
              }}
            />
          }
          // label={ticket.priority}
          label={translate(ticket.priority)}
          sx={{
            maxWidth: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: "0.875rem",
            fontWeight: 500,
            background:
              ticket.priority === "High"
                ? "#f8d7da"
                : ticket.priority === "Medium"
                ? "#fff3cd"
                : "#d4edda",
            color:
              ticket.priority === "High"
                ? "red"
                : ticket.priority === "Medium"
                ? "#856404"
                : "#155724",
          }}
        />
      </div>

      <div
        style={{
          width: "10%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRight: "1px solid lightgrey",
          padding: "0 8px",
          boxSizing: "border-box",
        }}
      >
        <Chip
          // label={ticket.status}
          label={translate(statusKeyMap[ticket.status] || ticket.status)}
          sx={{
            maxWidth: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: "0.875rem",
            fontWeight: 500,
            bgcolor: statusBg,
            color: statusColor,
          }}
        />
      </div>

      {/* Date */}
      <div
        style={{
          width: "12%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRight: "1px solid lightgrey",
          fontSize: "12px",
        }}
      >
        {new Date(ticket.createdAt.seconds * 1000).toLocaleString()}
      </div>
    </Box>
  );
}
